import React, { Fragment } from 'react';

import PickupOrder from '../../../models/PickupOrder';

import Moment from 'moment';
import { Moment as MomentType } from 'moment';

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import { KeyboardDatePicker } from "@material-ui/pickers";
import CalendarToday from '@material-ui/icons/CalendarToday';

import style from './ordersDriver.module.css';

const styles = (theme: Theme) =>

  createStyles({

    root: {
      marginLeft: '2%',
      height: '21px',
      width: '55%',
    },
    datePickerInput: {
      '& input': {
       color: 'var(--primaryblue)',
       fontSize: '14px',
       paddingTop: '2px',
       paddingBottom: 0,
       backgroundColor: 'transparent',
       textTransform: 'uppercase'
      },
      '& button': {
        padding: 0,
        paddingBottom: '2px'
      }
    },
    input: {
      '& svg': {
        color: 'white'
      }
    }
  });

interface driverDODateTimeMobileProps {
  classes: any;
  order: PickupOrder;
  pickupDate: MomentType | string;
  pickupDateChange: (date: MomentType) => void;
};

const driverDODateTimeMobile = (props: driverDODateTimeMobileProps) => {

  const { classes, order } = props;

  return (
    <Fragment>

      <div className={ style.horizontalLine }></div>
      <div className={ style.flex }>
      <div className={ style.dropOffDate }>

        <div className={ style.pot }>Drop Off Date:</div>
    
          <KeyboardDatePicker
              format='DD MMM YYYY'
              value={ props.pickupDate }
              onChange= { () => props.pickupDateChange } 
              disabled={ !order.allowed_ops.update_date }
              InputProps={{ 
                className: classes.datePickerInput
              }}
              className={ `${ classes.root } ${ classes.input }`}
            />	  
  
      </div>

      <div className={ style.flex }>
        <div className={ [style.wrapper, style.width141].join(' ')}>
          <div className={ style.pot }>Drop Off Time:</div>
          <div className={ style.pod }>{ order.pickup_time? order.pickup_time.replace(/([\d]{2})([\d]{2})/,'$1:$2'): '' }</div>
        </div>
      </div>


</div>
      <div className={ style.flex }>

        <div className={ style.wrapper }>
          <div className={ style.pot }>Cut Off Date:</div>
          <div className={ style.pod }>{order.cutoff_date ?  Moment(order.cutoff_date).format('DD MMM YYYY').toUpperCase() : '' }</div>
        </div>

        <div className={ [style.wrapper, style.cutOffTime].join(' ')}>
          <div className={ style.pot }>Cut Off Time:</div>
          <div className={ style.pod }>{ order.cutoff_time? order.cutoff_time.replace(/([\d]{2})([\d]{2})/,'$1:$2'): '' }</div>
        </div>

      </div>

      <div className={ style.flex }>

        <div className={ style.wrapper }>
          <div className={ style.pot }>Assigned Dock:</div>
          <div className={ style.pod }>{ order.dock_name ? order.dock_name : 'Dock is not defined yet' }</div>
        </div>

      </div>

      <div className={ style.horizontalLine }></div>

    </Fragment>
  );
}

export default withStyles(styles)(driverDODateTimeMobile);